import * as React from 'react';
import { ProductWarrantyComponent } from '../../components/product-warranty/product-warranty';
import { IProductWarrantyViewProps } from './product-warranty';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: IProductWarrantyViewProps) => {
    if (props.productWarrantyComponentProps.productWarranties) {
        return (
            <Module
                {...props.moduleProps}
                {...props.renderModuleAttributes(props)}
                className={props.productWarrantyComponentProps.className ?? 'mmx-product-warranty'}
            >
                <ProductWarrantyComponent {...props.productWarrantyComponentProps} />
            </Module>
        );
    }
    return renderViewNoWarranties();
};

export function renderViewNoWarranties(): JSX.Element | null {
    return <div></div>;
}
